export default ($http) => ({
  fetchAllCourses() {
    return $http.get('all-curriculum-maps')
  },
  fetchCourseMap(id, yearId) {
    return $http.get(`course-map/${id}${yearId ? `?yearId=${yearId}` : ''}`)
  },
  fetchUnitCalendarYear(id, yearId) {
    return $http.get(`course-map/${id}/calendar-year${yearId ? `?yearId=${yearId}` : ''}`)
  },
  fetchCourseWithCurriculum(id, yearId, params) {
    return $http.get(`curriculum-map/${id}/with-curriculum`, { query: { yearId, ...params } })
  },
  fetchCourse(id, yearId) {
    return $http.get(`curriculum-map/${id}${yearId ? `?yearId=${yearId}` : ''}`)
  },
  fetchForCalendar (showUsersCoursesOnly = true) {
    return $http.get(`${showUsersCoursesOnly ? 'my-courses-for-calendar-with-markers' : 'courses-with-markers'}`)
  },
  fetchCourseMapActivity(id, params) {
    return $http.get(`notifications-by-map/${id}`, { query: params })
  },
  updateCourse(id, payload) {
    return $http.put(`curriculum-map/${id}`, { body: payload })
  },
  addToFavorites(id) {
    return $http.post(`curriculum-map/${id}/add-to-favorites`)
  },
  removeFromFavorites(id) {
    return $http.delete(`curriculum-map/${id}/remove-from-favorites`)
  },
  updateUnitsOrder(id, payload) {
    return $http.put(`curriculum-map/${id}/sort-units`, { body: payload })
  },
  updateCoursePlanFilters(id, payload) {
    return $http.put(`curriculum-map/${id}/filter-preferences`, { body: payload })
  },
  fetchRecycledUnits(id, query) {
    return $http.get(`units-recycle/${id}`, { query })
  },
  recycleUnit(unitId) {
    return $http.delete(`units/${unitId}`)
  },
  removeRecycledUnits(mapId, unitIds) {
    return $http.post(`units-recycle/${mapId}/delete`, { body: { unitIds } })
  },
  restoreRecycledUnits(mapId, unitIds) {
    return $http.post(`units-recycle/${mapId}/restore`, { body: { unitIds } })
  },
  shareCourseMap(courseMapId, payload) {
    return $http.post(`share/curriculumMap/${courseMapId}`, { body: payload })
  },
  fetchCalendarMonth({ courseMapId, month, yearId, lessons }) {
    return $http.get(`course-map/${courseMapId}/calendar-month/${month}`, { query: { yearId, lessons } })
  },
  fetchMyCoursesForLessonCalendar() {
    return $http.get('/my-lessons-calendar/courses')
  },
  updateMyCourses(courses) {
    return $http.put('/my-lessons-calendar/courses', { body: courses })
  },
  updateMyCoursesSort(courses) {
    return $http.put('/my-lessons-calendar/courses/sort', { body: { courses } })
  },
  updateMyCourse(course) {
    return $http.put(`/my-lessons-calendar/courses/${course.id}`, { body: course })
  },
  fetchLessonsByMyCourses({ month, yearId, lessons, showLessonsInOtherCourses, showLessonsInRecycledCourses, lessonDescription = false }) {
    return $http.get(`/my-lessons-calendar/month/${month}`, { query: { yearId, lessons, showLessonsInOtherCourses, showLessonsInRecycledCourses, ...(lessonDescription && { lessonDescription }) } })
  },
  fetchMyCourses(query) {
    return $http.get('/my-courses', { query })
  },
  getMCoursesPageSettings() {
    return $http.get('/my-courses-settings')
  },
  fetchBrowsePageCourses(query) {
    return $http.get('/browse-courses', { query })
  },
  fetchBrowsePageCourseNames(query) {
    return $http.get('/browse-courses-names', { query })
  },
  fetchBrowsePageUsers(query) {
    return $http.get('/browse-courses-users', { query })
  },
  fetchAllPublicCourses(query) {
    return $http.get('/browse-courses-public', { query })
  },
  fetchBrowsePageCourseNamesPublic(query) {
    return $http.get('/browse-courses-names-public', { query })
  },
  fetchBrowsePageUsersPublic(query) {
    return $http.get('/browse-courses-users-public', { query })
  },
  updateLessonsOrderInCourse(payload, courseId, withNoUnits = 1) {
    return $http.put(`/curriculum-map/${courseId}/sort-lessons?withNoUnits=${withNoUnits}`, { body: payload })
  }
})
